module.exports = __webpack_public_path__ + "img/vegetable-taro-350x184.37ddf6d3.jpg";